import request from "@utils/request";

/**
 * 客户取消登记 提交
 * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=210#6435
 */
export function postSubmit(data) {
    return request({
        url: "/service/mg/cancel-register/submit",
        method: "POST",
        data
    });
}

/**
 * 客户取消登记 根据 po 查询详情
 * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=210#6434
 */
export function postCodeInfo(data) {
    return request({
        url: "/service/mg/cancel-register/code-info",
        method: "POST",
        data
    });
}
